import { useState } from 'react';
import './NumberCustomSelector.css'

const NumberCustomSelector = ({ defaultValue, className, onChange, options }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedValue, setSelectedValue] = useState(defaultValue);

	const handleOptionClick = (value) => {
		setSelectedValue(value);
		setIsOpen(false);
		onChange(value);
	};

	const selectedOption = options.find((opt) => opt.value === selectedValue) || options[0];

	return (
		<div className={`custom-selector ${className} ${isOpen ? 'open' : ''}`}>
			<div className="custom-selector__selected" onClick={() => setIsOpen(!isOpen)}>
				{selectedOption.label}
				<span className="custom-selector__arrow">▼</span>
			</div>

			{isOpen && (
				<div className="custom-selector__options">
					{options.map((option) => (
						<div
							key={option.value}
							className={`custom-selector__option ${
									option.value === selectedValue ? 'selected' : ''
							}`}
							onClick={() => handleOptionClick(option.value)}
					>
							{option.label}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default NumberCustomSelector;
